import { C } from '../../MapSharedData';

interface Props {
  x: number;
  y: number;
  label: string;
  /** When true, ignore x/y and center over the viewport — used for initial country load. */
  centered?: boolean;
}

/**
 * Compact loader anchored to a specific point on the map. Used in two modes:
 * - Anchored: pass x/y screen coordinates (e.g. center of a loading region)
 * - Centered: pass `centered` to position at viewport center (initial country load)
 */
export function RegionLoader({ x, y, label, centered = false }: Props) {
  // Position must remain inline — dynamic pixel coords from map.project()
  const positionStyle: React.CSSProperties = centered
    ? { top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }
    : { top: y, left: x, transform: 'translate(-50%, -50%)' };

  return (
    <div
      className="absolute z-[18] pointer-events-none flex flex-col items-center gap-1.5"
      style={positionStyle}
    >
      <style>{`
        @keyframes regionLoaderSpin {
          to { transform: rotate(360deg); }
        }
      `}</style>
      <div
        className="w-[22px] h-[22px] rounded-full"
        style={{
          border: `2px solid rgba(255, 255, 255, 0.65)`,
          borderTopColor: C.primary,
          animation: 'regionLoaderSpin 0.7s linear infinite',
          boxShadow: '0 2px 6px rgba(31,60,78,0.25)',
        }}
      />
      <div className="bg-white/95 backdrop-blur-sm border border-v2blueGray-200 rounded-md px-2 py-0.5 text-[11px] text-v2blueGray-900 font-medium whitespace-nowrap shadow-ui-kit-base">
        {label}
      </div>
    </div>
  );
}
